import { forwardRef, useImperativeHandle } from 'react'
import { useDisclosure } from '@mantine/hooks'
import { Drawer, Title, type TitleOrder } from '@mantine/core'
import { sendSignal } from '@shared/port-send-v1.0.0'
import type { Props } from '../node/definition'

export default forwardRef((p: Props, ref) => {
	const [opened, { open, close }] = useDisclosure(false)
	useImperativeHandle(
		ref,
		() => ({
			open() {
				open()
			},
			close() {
				close()
			},
		}),
		[]
	)

	return (
		<Drawer.Root
			onClose={() => {
				close()
				sendSignal(p.noodlNode, 'closed')
			}}
			{...p}
			size={p.sizeUnits || p.sizePresets}
			opened={opened}
			position={p.position}
			{...p.customProps}
		>
			<Drawer.Overlay opacity={p.drawerOpacity} blur={p.drawerBlur} />
			<Drawer.Content>
				{p.header && (
					<Drawer.Header>
						{p.title && (
							<Drawer.Title>
								<Title order={Number.parseInt(p.titleOrder) as TitleOrder}>{p.title}</Title>
							</Drawer.Title>
						)}
						{p.closeAction && <Drawer.CloseButton />}
					</Drawer.Header>
				)}
				<Drawer.Body>{p.children}</Drawer.Body>
			</Drawer.Content>
		</Drawer.Root>
	)
})
